import React from 'react';
import Navbar from '../components/main/Navbar';
import Footer from '../components/main/Footer';
import { Outlet } from 'react-router-dom';
import '../assets/styles/Layout.css'; // import your CSS

const MainLayout = () => {
  return (
    <div className="d-flex flex-column vh-100">
      {/* Navbar - 8vh */}
      <div className="navbar-wrapper w-100">

        <Navbar />
      </div>

      {/* Main Content - 86vh */}
      <main className="main-content-area flex-grow-1 overflow-auto">
        <Outlet />
      </main>

      {/* Footer - 6vh */}
      <div className="footer text-dark">
        <Footer />
      </div>
    </div>
  );
};

export default MainLayout;
